// Fetch language data
export const FETCH_LANGUAGE_DATA_REQUEST = 'FETCH_LANGUAGE_DATA_REQUEST';
export const FETCH_LANGUAGE_DATA_SUCCESS = 'FETCH_LANGUAGE_DATA_SUCCESS';
export const FETCH_LANGUAGE_DATA_FAILURE = 'FETCH_LANGUAGE_DATA_FAILURE';

// Upload file
export const UPLOAD_LANGUAGE_FILE_START = 'UPLOAD_LANGUAGE_FILE_START';
export const UPLOAD_LANGUAGE_FILE_PROGRESS = 'UPLOAD_LANGUAGE_FILE_PROGRESS';
export const UPLOAD_LANGUAGE_FILE_SUCCESS = 'UPLOAD_LANGUAGE_FILE_SUCCESS';
export const UPLOAD_LANGUAGE_FILE_FAILURE = 'UPLOAD_LANGUAGE_FILE_FAILURE';
export const UPLOAD_LANGUAGE_FILE_CANCEL = 'UPLOAD_LANGUAGE_FILE_CANCEL';
export const REMOVE_UPLOADED_FILE = 'REMOVE_UPLOADED_FILE';

// Import language data
export const IMPORT_LANGUAGE_DATA_REQUEST = 'IMPORT_LANGUAGE_DATA_REQUEST';
export const IMPORT_LANGUAGE_DATA_SUCCESS = 'IMPORT_LANGUAGE_DATA_SUCCESS';
export const IMPORT_LANGUAGE_DATA_FAILURE = 'IMPORT_LANGUAGE_DATA_FAILURE';

// Update language selection
export const UPDATE_LANGUAGE_SELECTION = 'UPDATE_LANGUAGE_SELECTION';

// Download template
export const DOWNLOAD_TEMPLATE_REQUEST = 'DOWNLOAD_TEMPLATE_REQUEST';
export const DOWNLOAD_TEMPLATE_SUCCESS = 'DOWNLOAD_TEMPLATE_SUCCESS';
export const DOWNLOAD_TEMPLATE_FAILURE = 'DOWNLOAD_TEMPLATE_FAILURE';
export const TOGGLE_DOWNLOAD_SECTION = 'TOGGLE_DOWNLOAD_SECTION';

// Reset state
export const RESET_LANGUAGE_DIALOG_STATE = 'RESET_LANGUAGE_DIALOG_STATE';

// Set file format
export const SET_FILE_FORMAT = 'SET_FILE_FORMAT';

//Error popup
export const SHOW_CONFIRMATION_DIALOG = 'SHOW_CONFIRMATION_DIALOG';
export const HIDE_CONFIRMATION_DIALOG = 'HIDE_CONFIRMATION_DIALOG';
export const SET_LANGUAGES_TO_REMOVE = 'SET_LANGUAGES_TO_REMOVE';
export const SET_PENDING_SELECTION = 'SET_PENDING_SELECTION';
export const SET_INITIAL_SELECTION = 'SET_INITIAL_SELECTION';